const getAccountType = (email) => {
  return new RegExp(
    `@(rogers|telus|bell|gmail|yahoo|outlook|me|icloud|sympatico|hotmail|ymail|ryerson|utoronto|queensu)`,
    "i"
  ).test(email)
    ? "Personal"
    : "Work"
}

module.exports = {
  getAccountType,
}
